<script lang="ts">
    interface Props {
        text: string | null | undefined;
    }

    let { text }: Props = $props();
</script>

{#if text}
    <span class="oc-copy-75" data-testid="AvailabilityText">
        {text}
    </span>
{/if}
